import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { Root } from './root.component';
import { FixedRoutes } from './fixed_routes.component';
import { Heading } from './heading.component';
import { ListRoot } from './list_root.component';
import { SelectedAppointmentCase } from './selected_appointment_case.component';
import { SelectedMessagingCase } from './selected_messagingCase.component';
import { Spacer, useBreakpoint, BreakPoints } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { DEFAULT_LAYOUT_VARIANT } from '../../constants';
import { applicationLocalStorage } from '@application/application_storage_local';
import { LegacyShell3Layout } from './legacy_shell-3_layout.component';

interface Props {}

const VARIANT = applicationLocalStorage.get('shell-variant') ?? DEFAULT_LAYOUT_VARIANT;

export function ViewPatientCases(_: Props) {
	const breakPoint = useBreakpoint(BreakPoints.Medium | BreakPoints.Small);

	return (
		<ViewPatientCases.Root>
			{breakPoint ? <Spacer vertical={tokens.spacing.x6} /> : null}

			{/* Ideally remove shell-3. We don't want to use shell-3 checks invariantly everywhere. */}
			{VARIANT === 'shell-3' ? <LegacyShell3Layout /> : <ViewPatientCases.FixedRoutes />}
		</ViewPatientCases.Root>
	);
}
// This is mostly done to make it easier to compose in Patient Old.
// If all was in React we would not need to do this.
ViewPatientCases.Root = Root;
ViewPatientCases.FixedRoutes = FixedRoutes;
ViewPatientCases.Heading = Heading;
ViewPatientCases.ListRoot = ListRoot;
ViewPatientCases.AppointmentCase = SelectedAppointmentCase;
ViewPatientCases.MessagingCase = SelectedMessagingCase;
ViewPatientCases.ViewNotFound = ViewNotFound;
